import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requirePaid = false }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <div className="font-mono text-moss" data-testid="auth-loading">checking session…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requirePaid && !user.paid) return <Navigate to="/activate" replace />;
  return children;
}
